import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { Button, Modal } from '@/ui';
import judicatures from '@/assets/judicatures.json';
import NuevaCausa from '@/pages/causas/NuevaCausaForm';

const cortes = judicatures.map((j) => ({
  cod: String(j.value),
  label: j.label,
}));
const tribunalesPorCorte = Object.fromEntries(
  judicatures.map((j) => [
    String(j.value),
    (j.tribunals ?? []).map((t) => ({ cod: String(t.value), label: t.label })),
  ]),
);

export default function AceptarWhatsAppModal({
  dialog,
  termsLine,
  busy,
  onClose,
  onSubmit,
  onRetry,
}) {
  const retryRef = useRef(null);
  const retrying = Boolean(dialog.retryBody);
  useEffect(() => {
    if (retrying && !busy) retryRef.current?.focus();
  }, [retrying, busy]);
  return (
    <Modal open onClose={onClose} size="default" closeOnBackdrop={!busy}>
      <div className="modal-head">
        <h3>Aceptar pedido</h3>
        <button
          type="button"
          className="modal-close modal__x"
          aria-label="Cerrar"
          onClick={onClose}
          disabled={busy}
        >
          ×
        </button>
      </div>
      <Modal.Body>
        <p>
          Vas a aceptar el hilo de <b>{dialog.row.sender}</b> y crear su causa.
          La causa queda seguida por la cuenta personal de ese teléfono.
        </p>
        <p>{termsLine}</p>
        {dialog.error && (
          <div role="alert">
            <strong>{dialog.error.title}</strong>
            <p>{dialog.error.message}</p>
          </div>
        )}
        {dialog.retryBody ? (
          <>
            <p>
              {dialog.accepted
                ? 'El pedido quedó aceptado.'
                : 'El pedido puede haber quedado aceptado.'}{' '}
              Reintenta para terminar la creación de la causa{' '}
              <span style={{ whiteSpace: 'nowrap' }}>
                {dialog.retryBody.bookType}-{dialog.retryBody.rol}-
                {dialog.retryBody.year}
              </span>{' '}
              con los mismos datos.
            </p>
            {/* A plain button: ui/Button does not forward a ref, and the focus
                has to land here when the retry view opens. */}
            <button
              type="button"
              className="btn btn-md btn-seal"
              ref={retryRef}
              onClick={onRetry}
              disabled={busy}
            >
              {busy ? 'Procesando…' : 'Reintentar'}
            </button>
            <Button variant="ghost" onClick={onClose} disabled={busy}>
              Cerrar
            </Button>
          </>
        ) : (
          <NuevaCausa
            cortes={cortes}
            tribunalesPorCorte={tribunalesPorCorte}
            onSubmit={(data) =>
              onSubmit({
                bookType: data.libro,
                competence: data.competencia,
                courtCode: data.corte,
                tribunalCode: data.tribunal,
                rol: data.rol,
                year: data.anio,
              })
            }
            onCancel={onClose}
            isSubmitting={busy}
            submitLabel="Aceptar y crear la causa"
            submittingLabel="Procesando…"
            submitDisabled={dialog.terms?.alreadyAccepted === false}
            validateFutureYear
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

AceptarWhatsAppModal.propTypes = {
  dialog: PropTypes.object.isRequired,
  termsLine: PropTypes.string.isRequired,
  busy: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
};
